import propNames from "../propNames";

const isElHasProperty = (el, property) => {
  if (el.getAttribute(propNames.dataAttr).includes(property)) {
    return true;
  } else {
    return false;
  }
};

export default isElHasProperty;
